import React from 'react';
import styles from './PhotoSlider.module.css';
import vase1 from '../../../static/images/vase1.jpg';
import vase2 from '../../../static/images/vase2.jpg';
import vase3 from '../../../static/images/vase3.jpg';
import vase4 from '../../../static/images/vase4.jpg';
import vase5 from '../../../static/images/vase5.png';
import vase6 from '../../../static/images/vase6.jpg';

class PhotoSlider extends React.Component {

	render() {
		return (
			<div className={styles.photoSlider}>
				<img src={vase1} alt=""/>
				<img src={vase2} alt=""/>
				<img src={vase3} alt=""/>
				<img src={vase4} alt=""/>
				<img src={vase5} alt=""/>
				<img src={vase6} alt=""/>
				<div className="clear"/>
				<button onClick={() => this.props.modal(true)}>View Gallery <i className="fad fa-chevron-double-right"/></button>
				<div className="clear"/>
			</div>
		);
	}

}

export default PhotoSlider;